import { useState, useEffect } from 'react';

// Tracks whether the viewport is at/below the mobile breakpoint (768px), matching
// the off-canvas drawer breakpoint in bravo-app.css. Drives whether the pinned /
// expanded sidebar layout may render (it is desktop-only).
const QUERY = '(max-width: 768px)';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
